import React, { useState, useEffect } from "react";
import adminClasses from "../../../landing-pages/admin/admin.module.css";
import CandidateAdminModel from "../../../../models/admin/candidate/response/CandidateAdminModel";
import adminCandidateService from "../../../../services/admin/admin-candidate-service";
import toasterUtils from "../../../../utils/toaster-utils";
import ByPassPaymentGatewayGridComponent from "./ByPassPaymentGatewayGridComponent";
import modalUtils from "../../../../utils/modal-utils";
import loaderUtils from "../../../../utils/loader-utils";
import { TextField, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

const ByPassPaymentGatewayComponent = () => {
    const [candidateList, setCandidateList] = useState<CandidateAdminModel[]>([]);
    const [refreshCandidate, setRefreshCandidate] = useState<number>(2);
    const [uniqueIdSearch, setUniqueIdSearch] = useState<string>("");

    useEffect(() => {
        clearSearch();
    }, []);

    const getCandidates = (uniqueId: string) => {
        setRefreshCandidate(2);
        modalUtils.showLoader();
        adminCandidateService.getCandidateByUniqueId(uniqueId).then((res) => {
            modalUtils.closeModal();
            setCandidateList([]);
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            setCandidateList(res.items);
            setRefreshCandidate(refreshCandidate * 5);
        }).catch((error) => {
            modalUtils.closeModal();
            setRefreshCandidate(refreshCandidate * 5);
            toasterUtils.showError(error);
        });
    };

    const clearSearch = () => {
        setCandidateList([]);
        setUniqueIdSearch("");
        setRefreshCandidate(2);
    };

    const onByPassPaymentGatewayActionHandler = (candidateId: string) => {
        modalUtils.showLoader();
        adminCandidateService.byPassPaymentGateway(candidateId).then((res) => {
            modalUtils.closeModal();
            if (!res.isSuccess || res.errorMessages.length > 0) {
                toasterUtils.showError(res.errorMessages.toString());
                return;
            }
            toasterUtils.showSuccess(res.informationMessages.toString());
        }).catch((error) => {
            modalUtils.closeModal();
            toasterUtils.showError(error);
        });
    };

    return (
        <div className="card card-white">
            <div className="card-body">
                <div className="row">
                    <div className="col-md-4">
                        <TextField label="Candidate Unique Id" size="small" margin="normal" fullWidth variant="outlined" onChange={(e) => setUniqueIdSearch(e.target.value)} placeholder="Unique Id" autoComplete="off" />
                    </div>
                    <div className="col-md-4">
                        <Button variant="contained" color="success" onClick={() => getCandidates(uniqueIdSearch)} startIcon={<SearchIcon />} sx={{ ml: 2, mt: 2 }}>
                            Search
                        </Button>
                        <Button variant="contained" color="warning" onClick={() => clearSearch()} startIcon={<ClearIcon />} sx={{ ml: 2, mt: 2 }}>
                            Clear
                        </Button>
                    </div>
                </div>
                {candidateList.length > 0 && refreshCandidate > 2 &&
                    <ByPassPaymentGatewayGridComponent
                        key={refreshCandidate}
                        candidateList={candidateList}
                        onByPassPaymentGatewayAction={onByPassPaymentGatewayActionHandler} />
                }
            </div>
        </div>
    );

};
export default ByPassPaymentGatewayComponent;